import { message } from "antd";

export const toast = {
  success: (text, duration) => message.success(text, duration),
  error: (text, duration) => message.error(text, duration),
  info: (text, duration) => message.info(text, duration),
  warning: (text, duration) => message.warning(text, duration),
};
